import React from 'react'
import { Link, withRouter } from 'react-router-dom'
import { values } from 'lodash'


class OrganizationsNavi extends React.Component {
  constructor(props) {
    super(props)

    this.handleOrganizationChange = this.handleOrganizationChange.bind(this)
  }

  handleOrganizationChange(event) {
    this.props.history.push(`/admin/${event.target.value}/dashboard`)
  }


  render() {
    const { organizations, currentOrganizationId } = this.props

    return (
      <div className="uk-padding uk-background-muted">
        <ul className="uk-nav-default uk-nav-parent-icon" data-uk-nav>
          <div className="uk-margin">
            <div className="uk-form-controls">
              <select className="uk-select" id="form-stacked-select" value={currentOrganizationId} onChange={this.handleOrganizationChange}>
                {Object.keys(organizations).length > 0
                  && values(organizations).map((organization) => {
                    if (!organization.uuid) return null
                    return (
                      <option
                        key={organization.uuid}
                        value={organization.uuid}
                      >
                        {organization.name}
                      </option>
                    )
                  })
                }
              </select>
            </div>
          </div>
          <li className={(this.props.active === 'dashboard') ? 'uk-active' : ''}>
            <Link to={`/admin/${currentOrganizationId}/dashboard`}>Dashboard</Link>
          </li>
          <li className={(this.props.active === 'users') ? 'uk-active' : ''}>
            <Link to={`/admin/${currentOrganizationId}/users`}>Users</Link>
          </li>
          <li className={(this.props.active === 'plans') ? 'uk-active' : ''}>
            <Link data-test-id="organization-navi-training-plans" to={`/admin/${currentOrganizationId}/plans`}>Training Plans</Link>
          </li>
          <li className={(this.props.active === 'teams') ? 'uk-active' : ''}>
            <Link data-test-id="organization-navi-option-teams" to={`/admin/${currentOrganizationId}/teams`}>Teams</Link>
          </li>
          <li className={(this.props.active === 'reports') ? 'uk-active' : ''}>
            <Link data-test-id="organization-navi-option-reports" to={`/admin/${currentOrganizationId}/reports`}>Reports & Certificates</Link>
          </li>
          <li data-test-id="organization-navi-option-settings" className={(this.props.active === 'settings') ? 'uk-active' : ''}>
            <Link to={`/admin/${currentOrganizationId}/settings`}>Settings</Link>
          </li>
          <li>
            <a href="https://help.hackedu.io" target="_blank" rel="noopener noreferrer">
              Documentation
              <span className="uk-margin-small-left" data-uk-icon="icon: link" />
            </a>
          </li>
        </ul>
      </div>
    )
  }
}


export default withRouter(OrganizationsNavi)
